import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const createPreviewFun = createAsyncThunk(
  "preview/createPreview",
  async (data, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (key === "images" && Array.isArray(data[key])) {
          data[key].forEach((image, index) => {
            formData.append(`images[${index}]`, image);
          });
        } else {
          formData.append(key, data[key]);
        }
      });


      const response = await PrivateAxios.post(
        "/api/user/newconstruction/Constructioncreate",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          // headers: {
          //   "Content-Type": "application/json",
          // },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data);
        return rejectWithValue(error.response.data);
      } else if (error.request) {
        console.error("No response:", error.request);
        return rejectWithValue(error.request);
      } else {
        console.error("Error:", error.message);
        return rejectWithValue(error.message);
      }
    }
  }
);

const createPreviewSlice = createSlice({
  name: "createPreview",
  initialState: {
    loadingForm: false,
    errorForm: null,
    successForm: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createPreviewFun.pending, (state) => {
        state.loadingForm = true;
        state.errorForm = null;
        state.successForm = false;
      })
      .addCase(createPreviewFun.fulfilled, (state, action) => {
        state.loadingForm = false;
        state.successForm = true;
      })
      .addCase(createPreviewFun.rejected, (state, action) => {
        state.loadingForm = false;
        state.errorForm = action.payload;
      });
  },
});

export default createPreviewSlice.reducer;
